import { ShieldCheck, SealCheck, Barcode, HardHat } from "@phosphor-icons/react";
import { useSettings } from "../../lib/api";

export const TrustBar = () => {
  const { data: s } = useSettings();
  const items = [
    { icon: ShieldCheck, label: "SDVOSB", value: "Service-Disabled Veteran-Owned Small Business" },
    { icon: SealCheck, label: "UEI", value: s?.uei || "SAM.gov Registered" },
    { icon: Barcode, label: "CAGE Code", value: s?.cage || "Available Upon Request" },
    { icon: HardHat, label: "Licensed & Insured", value: "State of Michigan · OSHA Compliant" },
  ];

  return (
    <section data-testid="trust-bar" className="bg-canvas border-b border-line">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item, i) => (
          <div
            key={item.label}
            data-testid={`trust-item-${i}`}
            className={`flex items-start gap-4 p-8 border-line ${i > 0 ? "sm:border-l" : ""} ${
              i >= 2 ? "border-t lg:border-t-0" : "border-t sm:border-t-0"
            }`}
          >
            <item.icon size={26} className="text-blueprint shrink-0 mt-0.5" />
            <div>
              <p className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-blueprint">{item.label}</p>
              <p className="mt-1.5 text-sm text-sub leading-snug">{item.value}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
